import Container from "@/Components/Grid/Container";

import IconLayout from "@resources/show-apartment/during-visit/layout.png?format=webp&quality=90&imagetools";
import IconMaterials from "@resources/show-apartment/during-visit/materials.png?format=webp&quality=90&imagetools";
import IconLiving from "@resources/show-apartment/during-visit/living.png?format=webp&quality=90&imagetools";
import IconStorage from "@resources/show-apartment/during-visit/storage.png?format=webp&quality=90&imagetools";
import IconSurroundings from "@resources/show-apartment/during-visit/surroundings.png?format=webp&quality=90&imagetools";

const items = [
    {
        key: "layout",
        icon: IconLayout,
        title: "Układ funkcjonalny",
        description: (
            <>
                Przemyślany rozkład
                <br />i wykorzystanie przestrzeni
            </>
        ),
    },
    {
        key: "materials",
        icon: IconMaterials,
        title: (
            <>
                Materiały
                <br />
                wykończeniowe
            </>
        ),
        description: "Sprawdzone materiały wysokiej jakości",
    },
    {
        key: "living",
        icon: IconLiving,
        title: (
            <>
                Strefa
                <br />
                dzienna
            </>
        ),
        description: (
            <>
                Komfortowy salon
                <br />z aneksem kuchennym
            </>
        ),
    },
    {
        key: "storage",
        icon: IconStorage,
        title: "Przechowywanie",
        description: "Praktyczne rozwiązania ułatwiające życie",
    },
    {
        key: "surroundings",
        icon: IconSurroundings,
        title: "Okolica inwestycji",
        description: (
            <>
                Zieleń, komunikacja,
                <br />
                szkoły i tereny rekreacyjne
            </>
        ),
    },
];

export const DuringVisitSection = () => {
    return (
        <section className="py-14 lg:py-18">
            <Container>
                <h2 className="text-primary text-h3 leading-[40px] font-extrabold uppercase tracking-[0.8px] text-center mb-[60px] maxMd:mb-10">
                    Co zobaczysz podczas wizyty?
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className="flex flex-col items-center gap-5 p-8"
                        >
                            <img
                                src={item.icon}
                                alt=""
                                className="h-20 w-auto object-contain"
                                loading="lazy"
                            />
                            <div className="flex flex-col gap-1 w-full text-center">
                                <h3 className="text-primary text-h4 leading-h4 font-extrabold tracking-[0.6px]">
                                    {item.title}
                                </h3>
                                <p className="text-text text-p leading-p tracking-[0.45px]">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};
